/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Supplier } from '@src/app/model/supplier';

@Injectable({
  providedIn: 'root'
})
export class PreferredSupplierService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);

  protected get baseUrl() {
    return this.getAjaxPath('suppliers/preferred');
  }
  protected cache: Supplier[];
  protected typeString = 'Preferred Supplier';
}
@Injectable({
    providedIn: 'root'
})
export class OmcPreferredSupplierService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);

    protected get baseUrl() {
      return this.getAjaxPath('suppliers/preferred/omc');
    }
    protected cache: Supplier[];
    protected typeString = 'Preferred Supplier';
}
